import Base from 'netxcore@netx/core-asset/views/assetSetExpirationView';

import {faCalendar} from '@netx/core-icons';
const icons = Base.initializeIcons({
	faCalendar,
});

export default class AssetSetExpirationView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.icons = {...icons, ...opts.icons};
		super(opts);
	}
}
